module.exports = {
    HTTP: {
        POST: 'POST',
        GET: 'GET',
        DELETE: 'DELETE',
    },
};
